module.exports = __webpack_public_path__ + "img/complete-activities.7794de0e.svg";